/* Category enhancement and optional commissioning hold; no delivery rules or app API calls. */
(() => {
  'use strict';
  // A merchant-controlled commissioning hold only. When released, Dingdoong alone
  // decides readiness. Never inspect, set, or guess app cart attributes or slots.
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-gpp-checkout-hold="true"]');
    if (!control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.submitter?.dataset.gppCheckoutHold !== 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  const initialise = (root = document) => {
    root.querySelectorAll('.gpp-category-panel').forEach(panel => {
      if (panel.dataset.gppResponsiveReady) return;
      panel.dataset.gppResponsiveReady = 'true';
      const desktop = matchMedia('(min-width: 990px)');
      panel.open = desktop.matches;
      desktop.addEventListener('change', event => { panel.open = event.matches; });
    });
    root.querySelectorAll('[data-gpp-categories]').forEach((section) => {
      if (section.dataset.gppReady) return;
      section.dataset.gppReady = 'true';
      const filters = section.querySelector('.gpp-filters');
      const cards = Array.from(section.querySelectorAll('[data-gpp-category]'));
      if (!filters || !cards.length) return;
      filters.hidden = false;
      filters.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gpp-filter]');
        if (!button || !filters.contains(button)) return;
        const active = button.dataset.gppFilter;
        filters.querySelectorAll('button').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        let shown = 0;
        cards.forEach((card) => {
          card.hidden = active !== 'all' && card.dataset.gppCategory !== active;
          if (!card.hidden) shown += 1;
        });
        const status = section.querySelector('[data-gpp-filter-status]');
        if (status) status.textContent = `${shown} food categories shown`;
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
